import React from "react";
import { Link } from "react-router-dom";

import "../../utilities.css"
import "./PrevComms.css";

import { scrollToTop } from "../../utilities.js";

const PrevComms = ({prevComm, prevCommStartYear}) => {
  return (<>
    { prevComm.length > 0 ? (
      <div className="prevComm-container">
        {prevComm.map((item) => 
          <React.Fragment key={item.profile.username}>
            {
              (item.profile.display === true) ? (
                <Link 
                  className="prevComm-about"
                  to={`/profile/${item.profile.username}`}
                  onClick={scrollToTop}
                  >
                  <div className="prevComm-name">{item.profile.preferredName} </div>
                  <div className="prevComm-post">{item.committee_post.name} </div>
                  { item.notes && <div className="prevComm-note">{item.notes}</div> }
                </Link>
              ) : (
                <div className="prevComm-about">
                  <div className="prevComm-name">{item.profile.preferredName} </div>
                  <div className="prevComm-post">{item.committee_post.name} </div>
                  { item.notes && <div className="prevComm-note">{item.notes}</div> }
                </div>
              )
            }
          </React.Fragment>
          )}
      </div>
    ) : (
      <p>
        No committee records found for the year of {prevCommStartYear}-{prevCommStartYear+1}.
      </p>)}
    </>
  );
};
  
export default PrevComms;